import { connect } from 'react-redux'

import { loadingAction } from './actions'
import LoadingOverlayComponent from './LoadingOverlayComponent'

const mapStateToProps = (state) => {
  return {
    loading: state.loading,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onLoading: loading => dispatch(loadingAction(loading)),
  }
}

const LoadingOverlayContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(LoadingOverlayComponent)

export default LoadingOverlayContainer



// WEBPACK FOOTER //
// ./src/LoadingOverlayContainer.js